import React from 'react';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import ModalActions from 'app/shared/actions/ModalActions';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import contextUtils from 'app/shared/utils/contextUtils';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

// notification
import NotificationModule from 'app/client/workers/notificationModule';

// style
import './style.scss';

const NotificationPromptModal = ({ dispatch }) => {
    const dispatchGA = (eventParams) => {
        // get friendly ga label with context
        const labelPrefix = 'Pre-Prompt - ';
        const label = contextUtils.getPageContext(labelPrefix);
        dispatch(analyticsUtils.track.GAEventV2(eventParams, { label }));
    };

    const handleYesClick = () => {
        dispatchGA(AnalyticsConstants.GA_EVENTS.NOTIFICATION_PRE_PROMPT_GRANTED);
        NotificationModule.requestPermission();
        dispatch(ModalActions.hideModal());
    };

    const handleNoClick = () => {
        dispatchGA(AnalyticsConstants.GA_EVENTS.NOTIFICATION_PRE_PROMPT_DENIED);
        NotificationModule.setNotificationPromptCookieAsDeclined();
        dispatch(ModalActions.hideModal());
    };

    return (
        <div className="NotificationPromptModal-content">
            <div className="NotificationPromptModal-Body">
                <Text className="NotificationPrompModal-Body-Title" type="h4">Notify me when</Text>
                <ul className="NotificationPrompModal-Body-List">
                    <li className="NotificationPrompModal-Body-List-Item">
                        My listing is updated on Zillow, Trulia, and HotPads
                    </li>
                    <li className="NotificationPrompModal-Body-List-Item">
                        My listing is expiring soon
                    </li>
                </ul>
            </div>
            <div className="NotificationPromptModal-Actions">
                <Button
                    className="Actions-no"
                    type="tertiary"
                    onClick={handleNoClick}
                >
                    NOT NOW
                </Button>
                <Button
                    className="Actions-yes"
                    type="primary"
                    onClick={handleYesClick}
                >
                    YES
                </Button>
            </div>
        </div>
    );
};

export { NotificationPromptModal };
export default NotificationPromptModal;
